import {appendOfferListSearch, composeOfferListUrl, IOfferListUrlLinks} from "./compose_offer_list_url";
import {getOfferListUrlStrategy} from "./get_offer_list_url_strategy";
import {countOfferListFilters} from "./offer_list_url_filters";
import {IOfferListUrlInput} from "./offer_list_url_values";

export interface IBuildOfferListUrlOptions {
    links?: Partial<IOfferListUrlLinks>;
    /**
     * Keeps an existing subfilter segment (for example a canonical that already
     * decided `/blizniaki/`) when the active strategy still serves that address as a static path.
     */
    subFilterSlug?: string;
}

export const buildOfferListUrl = (query: IOfferListUrlInput, options?: IBuildOfferListUrlOptions): string => {
    const strategy = getOfferListUrlStrategy();
    const built = strategy.build(query);

    const canKeepExplicitSubFilter = !strategy.canonicalizeQuery || countOfferListFilters(query) === 0;
    const offerListSubFilterSlug = built.offerListSubFilterSlug || (canKeepExplicitSubFilter ? options?.subFilterSlug : undefined);

    return composeOfferListUrl({...built, offerListSubFilterSlug}, options?.links);
};

export const appendOfferListQuery = (url: string, query: IOfferListUrlInput): string =>
    appendOfferListSearch(url, query, getOfferListUrlStrategy().canonicalizeQuery);
import {appendOfferListSearch, composeOfferListUrl, IOfferListUrlLinks} from "./compose_offer_list_url";
import {getOfferListUrlStrategy} from "./get_offer_list_url_strategy";
import {countOfferListFilters} from "./offer_list_url_filters";
import {IOfferListUrlInput} from "./offer_list_url_values";

export interface IBuildOfferListUrlOptions {
    links?: Partial<IOfferListUrlLinks>;
    /**
     * Keeps an existing subfilter segment (for example a canonical that already
     * decided `/blizniaki/`) when the active strategy still serves that address as a static path.
     */
    subFilterSlug?: string;
}

export const buildOfferListUrl = (query: IOfferListUrlInput, options?: IBuildOfferListUrlOptions): string => {
    const strategy = getOfferListUrlStrategy();
    const built = strategy.build(query);

    const canKeepExplicitSubFilter = !strategy.canonicalizeQuery || countOfferListFilters(query) === 0;
    const offerListSubFilterSlug = built.offerListSubFilterSlug || (canKeepExplicitSubFilter ? options?.subFilterSlug : undefined);

    return composeOfferListUrl({...built, offerListSubFilterSlug}, options?.links);
};

export const appendOfferListQuery = (url: string, query: IOfferListUrlInput): string =>
    appendOfferListSearch(url, query, getOfferListUrlStrategy().canonicalizeQuery);
